export function feedInstitutionsTypePatcher(data) {
    return {
        institutions: data.institutions.map(institution => ({
            __typename: 'FeedInstitution',
            institutionId: institution.institutionId,
            title: institution.title,
            image: institution.image,
        })),
    };
}
